import { Pipe, PipeTransform } from '@angular/core';
import {
  getSubscriptionNameById,
  isHiddenGenesysCloudCXSubscriptionById,
} from '@app/utilities/_index';

import { Learning_Type } from '@app/enums/learning-type.enum';
import { environment } from '@environments/environment';

@Pipe({
  name: 'courseSubscriptionTooltip',
  standalone: false,
})
export class CourseSubscriptionTooltipPipe implements PipeTransform {
  /**
   * Return transformed information tooltip for a card type
   * @param toolTipInformation - tooltip information string to be added to the transformed result.
   * @param learningType - card type to transform to new display tooltip information
   * @returns - transformed tooltip string based on card type
   */
  public transform(toolTipInformation: number[], learningType: string): string {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return '';
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.WEBINAR:
      case Learning_Type.WORKSHOP:
      case Learning_Type.CERTIFICATION_EXAM:
      case Learning_Type.SELF_STUDY:
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
        if (toolTipInformation && toolTipInformation.length > 0) {
          let tooltipItems = '';
          // NOTE: Exclude or replace any Genesys Cloud Premier Partner Learning Subscription or Genesys Cloud TRIAL Subscription from being shown
          // to the user. These are unpublished or hidden Partner subscriptions that are not public at this time.
          // Default any of these to be Genesys Cloud
          let showGenesysCXOnce = false;
          for (const subscriptionId of toolTipInformation) {
            let dislayName = '';
            if (!isHiddenGenesysCloudCXSubscriptionById(subscriptionId)) {
              showGenesysCXOnce = true;
              dislayName = getSubscriptionNameById(subscriptionId);
              // NOTE: Do not show empty items in the tooltip
              if (dislayName) {
                tooltipItems += `<li>${dislayName}</li>`;
              }
            } else {
              // Else default to Genesys Cloud
              if (!showGenesysCXOnce) {
                dislayName = getSubscriptionNameById(
                  environment.beyond.genesys_cloud.subscription_id
                );
                tooltipItems += `<li>${dislayName}</li>`;
              }
            }
          }
          return `<p class="bold">This course is included in the following subscription(s): </p>
          <ul>
            ${tooltipItems}
          </ul>`;
        } else {
          return '';
        }
      default:
        return '';
    }
  }
}
